/**
 * Routini API — Management
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const TaxiTripTourChangeActorType = {
    ManagementUserAccount: 'ManagementUserAccount',
    TaxiDriver: 'TaxiDriver',
    System: 'System'
} as const;
export type TaxiTripTourChangeActorType = typeof TaxiTripTourChangeActorType[keyof typeof TaxiTripTourChangeActorType];

